var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.459 17.9706C19.459 12.0016 15.333 14.4386 11.959 14.4386C8.58498 14.4386 4.45898 12.0636 4.45898 17.9706C4.45898 18.8988 4.82773 19.7891 5.48411 20.4455C6.14049 21.1018 7.03073 21.4706 7.95898 21.4706H15.959C16.8872 21.4706 17.7775 21.1018 18.4339 20.4455C19.0902 19.7891 19.459 18.8988 19.459 17.9706Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4889 11.1846L21.5209 11.2076C21.5209 11.2076 24.1669 6.63558 20.9209 3.97058C18.9209 3.97058 15.8629 7.27058 15.8629 7.27058L15.8849 7.28658C13.3424 6.55356 10.6454 6.54802 8.09989 7.27058C8.08289 7.25558 5.03689 3.97058 3.04189 3.97058C-0.131106 6.57058 2.31289 10.9826 2.42789 11.1876C1.32051 12.8864 0.82821 14.9131 1.03289 16.9306C1.27389 20.0566 3.87989 23.4706 7.01489 23.4706H16.8999C20.0349 23.4706 22.6419 20.0566 22.8819 16.9306C23.0894 14.9122 22.5977 12.8838 21.4889 11.1846Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.48 19.4706C16.0323 19.4706 16.48 18.799 16.48 17.9706C16.48 17.1422 16.0323 16.4706 15.48 16.4706C14.9277 16.4706 14.48 17.1422 14.48 17.9706C14.48 18.799 14.9277 19.4706 15.48 19.4706Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47998 19.4706C9.03226 19.4706 9.47998 18.799 9.47998 17.9706C9.47998 17.1422 9.03226 16.4706 8.47998 16.4706C7.9277 16.4706 7.47998 17.1422 7.47998 17.9706C7.47998 18.799 7.9277 19.4706 8.47998 19.4706Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubVector);
export default __webpack_public_path__ + "static/media/github_vector.bda8e9d25c98330aa1f1231226627238.svg";
export { ForwardRef as ReactComponent };